import designItem from './DesignInputNumber.vue'
const DesignInputNumber = {
  install: function (Vue) {
    Vue.component('DesignInputNumber', designItem)
  }
}
export default DesignInputNumber
